import { Outlet, useLocation } from 'react-router-dom';
import GlobalSOSButton from '../components/GlobalSOSButton';
import AreaHeadSosListener from '../components/AreaHeadSosListener';
import AppNav from '../components/AppNav';
import { getSessionStatus, isLoggedIn } from '../utils/session';

export default function MainLayout() {
  const { pathname } = useLocation();
  // SOS is only available to approved members; pending/rejected applicants see a bare status page.
  const notApproved = isLoggedIn() && getSessionStatus() !== 'Active';
  const hideChrome = pathname === '/login' || pathname === '/apply' || notApproved;

  if (hideChrome) {
    return <Outlet />;
  }

  return (
    <>
      <AppNav />
      <AreaHeadSosListener />
      <GlobalSOSButton />
      <div className="with-sos-fab">
        <Outlet />
      </div>
    </>
  );
}
